import { render } from "./FlexMessageTemplateModal.vue?vue&type=template&id=0ce37d34&scoped=true"
import script from "./FlexMessageTemplateModal.vue?vue&type=script&lang=ts"
export * from "./FlexMessageTemplateModal.vue?vue&type=script&lang=ts"

import "./FlexMessageTemplateModal.vue?vue&type=style&index=0&id=0ce37d34&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0ce37d34"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QInput,QIcon,QCardSection,QTabs,QTab,QTable,QTr,QTh,QTd,QChip,QSpace});
